var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingIcon03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 66,
    viewBox: "0 0 87 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.1059 43.1939L48.438 64.9355H39.0887L10.0566 43.1939L47.9588 21.1414L86.1059 43.1939Z",
    fill: "#D6E1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1045 34.8038L39.2019 56.8563L1.05469 34.8038L38.9573 12.7512L77.1045 34.8038Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1997 20.4946L70.5765 38.6083L58.0293 45.7431L51.8789 45.7447L23.3379 28.0716L39.1997 20.4946Z",
    fill: "#D6E1FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1153 34.8489L77.0848 43.0727L39.1816 64.9709V56.747L77.1153 34.8489Z",
    fill: "#0C111D",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1704 56.6883V64.9999L1.05469 43.1017V34.7905L39.1704 56.6883Z",
    fill: "#0F55DC",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7578 44.9429V53.2631",
    stroke: "#0C111D",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 44.9757L43.3532 30.7927",
    stroke: "#0C111D",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8288 22.2228C30.441 22.5801 30.9173 23.4136 30.9173 24.1111C30.9173 24.8086 30.4242 25.0808 29.8116 24.7405C29.1995 24.3833 28.7227 23.5497 28.7227 22.8522C28.7227 22.1377 29.2162 21.8656 29.8288 22.2228Z",
    fill: "#4ACC3C",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3518 29.4353C42.9644 29.7926 43.4407 30.6262 43.4407 31.3237C43.4407 32.0212 42.9472 32.2933 42.335 31.9531C41.7224 31.5959 41.2461 30.7623 41.2461 30.0648C41.2633 29.3673 41.7396 29.0951 42.3518 29.4353Z",
    fill: "#4ACC3C",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4281 8.34033L51.8148 26.4579L51.7636 45.8513L20.377 27.7337L20.4281 8.34033Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3947 26.3551C48.3947 27.4098 49.1432 28.7027 50.0618 29.23L50.0274 41.0872C49.1259 40.5599 48.3775 40.9682 48.3603 42.0059L23.7785 27.8181C23.7612 26.7633 23.03 25.5045 22.1113 24.9771L22.1453 13.1199C23.064 13.6473 23.8124 13.222 23.8124 12.1672L48.3947 26.3551ZM36.0777 32.3772C38.1872 33.585 39.8888 32.2071 39.9055 29.2981C39.9055 26.372 38.2217 23.0208 36.1122 21.8129C34.0027 20.6051 32.3016 21.983 32.2844 24.892C32.2672 27.8011 33.9687 31.1524 36.0777 32.3772ZM29.8348 24.7389C30.447 25.0962 30.9405 24.807 30.9405 24.1095C30.9405 23.412 30.447 22.5614 29.8516 22.2212C29.2394 21.864 28.7459 22.1531 28.7459 22.8507C28.7287 23.5311 29.2222 24.3817 29.8348 24.7389ZM42.3551 31.9689C42.9677 32.3262 43.4612 32.037 43.4612 31.3395C43.4612 30.642 42.9677 29.7914 42.3723 29.4512C41.7597 29.094 41.2666 29.3832 41.2666 30.0806C41.2494 30.7611 41.7429 31.6117 42.3551 31.9689Z",
    fill: "#D6E1FB",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3947 26.3551C48.3947 27.4098 49.1432 28.7027 50.0618 29.23L50.0274 41.0872C49.1259 40.5599 48.3775 40.9682 48.3603 42.0059L23.7785 27.8181C23.7612 26.7633 23.03 25.5045 22.1113 24.9771L22.1453 13.1199C23.064 13.6473 23.8124 13.222 23.8124 12.1672L48.3947 26.3551ZM36.0777 32.3772C38.1872 33.585 39.8888 32.2071 39.9055 29.2981C39.9055 26.372 38.2217 23.0208 36.1122 21.8129C34.0027 20.6051 32.3016 21.983 32.2844 24.8921C32.2672 27.8011 33.9687 31.1524 36.0777 32.3772ZM29.8348 24.7389C30.447 25.0962 30.9405 24.807 30.9405 24.1095C30.9405 23.412 30.447 22.5614 29.8516 22.2212C29.2394 21.864 28.7459 22.1531 28.7459 22.8507C28.7287 23.5311 29.2222 24.3817 29.8348 24.7389ZM42.3551 31.9689C42.9677 32.3262 43.4612 32.037 43.4612 31.3395C43.4612 30.642 42.9677 29.7914 42.3723 29.4512C41.7597 29.094 41.2666 29.3832 41.2666 30.0806C41.2494 30.7611 41.7429 31.6117 42.3551 31.9689Z",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1033 21.7968C38.2128 23.0046 39.9139 26.373 39.8967 29.282C39.8967 32.208 38.1784 33.5859 36.0694 32.3611C33.9599 31.1533 32.2583 27.8019 32.2755 24.8759C32.2755 21.9669 33.9938 20.5889 36.1033 21.7968Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8125 26.4554L57.8005 22.968L57.7494 42.407L51.7441 45.8774L51.8125 26.4554Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4199 8.33971L26.4251 4.85229L57.7946 22.9698L51.8066 26.4572L20.4199 8.33971Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2309_2354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 4,
    width: 38,
    height: 42
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.431 4.84863L20.4258 8.33604L51.8124 26.4536L57.8004 22.9662L26.431 4.84863Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7474 42.4507L57.7981 22.9661L51.8101 26.4535L51.7422 45.921L57.7474 42.4507Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2309_2354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6152 7.08911L54.0019 25.2066L53.9507 44.6",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6602 5.91553L56.0468 24.033L55.9961 43.4265",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 35.5776C1 36.9352 1.91564 38.2933 3.71543 39.3035C7.28338 41.3244 13.0616 41.2924 16.5664 39.2085C18.303 38.1668 19.1873 36.8407 19.1873 35.4831V33.0518C19.1873 34.3779 18.3346 35.7355 16.5664 36.7772C13.03 38.8616 7.28338 38.8931 3.71543 36.8722C1.91564 35.862 1 34.5039 1 33.1462V35.5776Z",
    fill: "#0F55DC",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5648 36.7793C20.1011 34.6953 20.0382 31.3483 16.4701 29.3274C12.9021 27.3067 7.12384 27.3383 3.61903 29.4223C0.0826771 31.5062 0.145812 34.8533 3.71376 36.8737C7.28175 38.8947 13.0599 38.8632 16.5648 36.7793Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1484 32.5891C19.3856 34.0801 18.5312 35.6247 16.57 36.7801C14.6902 37.8981 12.1564 38.4251 9.66034 38.3621C9.25847 36.8568 10.0465 35.2483 12.0342 34.0683C13.9665 32.9301 16.6053 32.4371 19.1484 32.5891Z",
    fill: "#D6E1FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5648 36.7793C20.1011 34.6953 20.0382 31.3483 16.4701 29.3274C12.9021 27.3067 7.12384 27.3383 3.61903 29.4223C0.0826771 31.5062 0.145812 34.8533 3.71376 36.8737C7.28175 38.8947 13.0599 38.8632 16.5648 36.7793Z",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 31.3933V32.5846C4.88867 33.3483 5.3958 34.1179 6.3978 34.6985C8.42016 35.8775 11.7133 35.8775 13.754 34.6985C14.7866 34.112 15.2937 33.3301 15.2937 32.5541L15.2876 31.3628C15.2876 32.1383 14.7805 32.9143 13.754 33.5072C11.7133 34.6862 8.42016 34.6862 6.3978 33.5072C5.3958 32.9207 4.88867 32.157 4.88867 31.3933Z",
    fill: "#E8E8E8",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89454 31.3925C4.88981 29.7288 7.21391 28.3736 10.0855 28.3653C12.957 28.3574 15.2888 29.6993 15.2935 31.363C15.2982 33.0266 12.9741 34.3818 10.1026 34.3897C7.23098 34.398 4.89926 33.0557 4.89454 31.3925Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20312 29.1569L6.20938 30.3753C6.20938 30.9505 6.58438 31.5194 7.34059 31.9568C8.85307 32.8381 11.3155 32.8381 12.8342 31.9568C13.6029 31.513 13.9842 30.9318 13.9842 30.3566L13.9779 29.1318C13.9779 29.713 13.5967 30.2941 12.828 30.7316C11.303 31.6128 8.84681 31.6128 7.33434 30.7316C6.58438 30.3005 6.20937 29.7253 6.20312 29.1569Z",
    fill: "#E8E8E8",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35156 27.5483C5.82659 28.4291 5.82034 29.8542 7.33281 30.7291C8.84529 31.6045 11.3077 31.6104 12.8264 30.7291C14.3514 29.8542 14.3576 28.4291 12.8452 27.5483C11.3327 26.6668 8.87028 26.6668 7.35156 27.5483Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4203 29.5233C12.1465 29.081 12.1465 28.3867 11.3887 27.9758C10.6309 27.5654 9.46266 27.5654 8.70482 28.0078C7.97863 28.4496 7.97863 29.1444 8.73641 29.5548C9.4942 29.9652 10.6625 29.9652 11.4203 29.5233Z",
    fill: "#0C111D",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0605 1.95044C10.7867 1.95044 11.3867 2.55037 11.3867 3.27662V27.9368C11.3867 27.9683 11.3867 27.9683 11.3867 27.9683V29.5469C10.6604 29.9573 9.49216 29.9573 8.73438 29.5469V3.24503C8.73438 2.55037 9.33431 1.95044 10.0605 1.95044Z",
    fill: "white",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0605 9.56055C10.7867 9.56055 11.3867 10.1605 11.3867 10.8867V15.7808C10.9762 15.844 10.5342 15.9071 10.0921 15.9071C9.61848 15.9071 9.17645 15.844 8.73438 15.7808V10.8867C8.73438 10.1605 9.33431 9.56055 10.0605 9.56055Z",
    fill: "#D6E1FB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3452 12.9392C7.0497 13.0751 4.26803 10.5137 4.13212 7.21823C3.99626 3.92275 6.55763 1.14103 9.85311 1.00517C13.1486 0.869258 15.9303 3.43063 16.0662 6.72611C16.2021 10.0217 13.6407 12.8033 10.3452 12.9392Z",
    fill: "#618EE4",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93765 3.05981C7.78357 3.14863 6.09813 4.97903 6.18695 7.13312",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83066 10.5712C12.1237 10.4354 14.6875 7.65112 14.5517 4.35809C14.5271 3.76387 14.4046 3.19848 14.2336 2.65991C15.2927 3.68268 15.9967 5.11696 16.062 6.70157C16.1978 9.99455 13.634 12.7789 10.341 12.9146C7.81552 13.0188 5.59712 11.5478 4.63867 9.35515C4.86561 9.44501 5.09148 9.51011 5.31738 9.57516C6.31259 10.2534 7.54321 10.6242 8.83066 10.5712Z",
    fill: "#0F55DC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3452 12.9392C7.0497 13.0751 4.26803 10.5137 4.13212 7.21823C3.99626 3.92275 6.55763 1.14103 9.85311 1.00517C13.1486 0.869258 15.9303 3.43063 16.0662 6.72611C16.2021 10.0217 13.6407 12.8033 10.3452 12.9392Z",
    stroke: "#0C111D",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon03);
export default __webpack_public_path__ + "static/media/pricing-icon03.5fde74e5329ff8070f8e68865cd49599.svg";
export { ForwardRef as ReactComponent };